export default "__VITE_ASSET__Da20Kv1p__"